export default {
  labelHidden: '标签显隐',
  streetMap: '街道图',
  imageMap: '影像图',
  open: '展开',
  putitaway: '收起',
  deviceTotal: '设备总数',
  deviceRun: '设备运行',
  deviceStop: '设备停机',
  deviceFault: '设备故障',
  deviceOffline: '设备离线'
}
